import { useEffect, useState } from "react";

export function useNow(intervalMs = 15000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

// 12:01am–12 noon morning, 12 noon–6pm afternoon, 6pm–midnight evening
export function greeting(d) {
  const mins = d.getHours() * 60 + d.getMinutes();
  if (mins >= 1 && mins < 720) return "Good morning";
  if (mins >= 720 && mins < 1080) return "Good afternoon";
  return "Good evening";
}

const SEASON_LINES = {
  Summer: [
    "Summer's here: slip, slop, slap and wrap.",
    "Long light evenings and warm sand. Don't forget the SPF 50.",
    "Beach season is on. Find some shade between 11 and 4.",
    "Pōhutukawa in bloom, sea at its warmest. Get out there.",
    "Hot days, cool water, fewer layers. Summer done right.",
  ],
  Autumn: [
    "Autumn: golden light, quieter beaches, still-warm sea.",
    "The crowds are gone and the water's still warm. Perfect timing.",
    "Crisp mornings, warm afternoons. Ideal for a long coastal walk.",
    "Autumn sun is gentler, but it still pays to cover up by midday.",
  ],
  Winter: [
    "Winter: perfect for hot pools.",
    "Cold outside? Geothermal pools and a warm towel are waiting.",
    "Short days, long soaks. Winter is hot-spring season.",
    "Clear winter skies and steaming pools. Rotorua is calling.",
  ],
  Spring: [
    "Spring: the first warm days are back. The UV climbs faster than you'd think.",
    "Spring sun and fresh bush tracks. Ease back into the season.",
    "New season, fresh air. Time to dust off the beach towel.",
    "Lambs, blossom and the first swim of the year, if you're brave.",
  ],
};

export function getSeason(d, lat) {
  const m = d.getMonth();
  const south = lat == null || lat < 0;
  const idx = south ? [0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3, 0][m] : [2, 2, 3, 3, 3, 0, 0, 0, 1, 1, 1, 2][m];
  return ["Summer", "Autumn", "Winter", "Spring"][idx];
}

// Random line per visit (cached for the page load), never the same as the visitor's previous one
const visitPick = {};
const lastKey = (season) => `kb_season_last_${season}`;

export function pickSeasonLine(season) {
  const lines = SEASON_LINES[season];
  if (visitPick[season] == null) {
    const last = Number(localStorage.getItem(lastKey(season)));
    let i = Math.floor(Math.random() * lines.length);
    if (lines.length > 1 && i === last) i = (i + 1) % lines.length;
    visitPick[season] = i;
  }
  return lines[visitPick[season]];
}

export function rememberSeasonLine(season) {
  if (visitPick[season] != null) localStorage.setItem(lastKey(season), String(visitPick[season]));
}

export const formatLongDate = (d) =>
  d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });

export const formatTime = (d) =>
  d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZoneName: "short" });
